<template>
  <v-app id="inspire">
    <v-content>
      <v-container>
        <v-card
          class="mx-auto"
          max-width="344"
          outlined
        >
          <v-list-item three-line>
            <v-list-item-content>
              <div class="overline mb-4">Line通知</div>
              <v-list-item-title class="headline mb-1">明日の予定シフトを送信</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-card-actions>
            <v-btn @click="infoLine()">Line送信</v-btn>
          </v-card-actions>
        </v-card>

        <v-snackbar
          v-model="snackbar"
          color="success"
          :timeout=2000
        >
          {{ msg }}
          <v-btn
            @click="snackbar = false"
          >
            閉じる
          </v-btn>
        </v-snackbar>

      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import Auth from '@/components/Auth'
import moment from 'moment'
export default {
  mixins: [ Auth ],
  data: () => ({
   snackbar: '',
  }),
  mounted () {
  },
  computed: {
   },
   methods: {
    infoLine () {

      var self = this
      this.$axios.post(this.url + 'infoLine.php', JSON.stringify({
        kaisi: moment().add(1, 'days').format('YYYY-MM-DD'),
        hiduke: moment().add(1, 'days').format('YYYY年MM月DD日(ddd)')
      })).then(function () {
        self.msg = '送信しました。'
        if (self.msg !== '') {
          self.snackbar = true
        }
      })

    },
},
  props: {
    source: String
  }
}
</script>

<style lang="stylus">
</style>
